export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8196.9149710d.jpg";